import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { FaqRoutingModule } from './faq-routing.module';
import { GraphqlModule } from '@myclubrewards/graphql';
import { FaqComponent } from './components/faq/faq.component';
import { FaqCategoryComponent } from './components/faq-category/faq-category.component';
import { FaqCategoryQaComponent } from './components/faq-category-qa/faq-category-qa.component';
import { AdminSharedModule } from '../../../shared/admin-shared.module';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    FaqRoutingModule,
    GraphqlModule,
    AdminSharedModule,
  ],
  declarations: [FaqComponent, FaqCategoryComponent, FaqCategoryQaComponent],
  exports: [FaqComponent, FaqCategoryComponent, FaqCategoryQaComponent],
})
export class FaqModule {}
